export class SessionController {
    private listeners = {
        revoke: new Set<() => void>(),
        signin: new Set<() => void>(),
        signout: new Set<() => void>(),
    };

    addEventListener(event: 'revoke' | 'signin' | 'signout', listener: () => void) {
        switch (event) {
            case 'revoke':
                this.listeners.revoke.add(listener);
                break;
            case 'signin':
                this.listeners.signin.add(listener);
                break;
            case 'signout':
                this.listeners.signout.add(listener);
                break;
        }
    }

    removeEventListener(event: 'revoke' | 'signin' | 'signout', listener: () => void) {
        switch (event) {
            case 'revoke':
                this.listeners.revoke.delete(listener);
                break;
            case 'signin':
                this.listeners.signin.delete(listener);
                break;
            case 'signout':
                this.listeners.signout.delete(listener);
                break;
        }
    }

    signIn() {
        for (const listener of this.listeners.signin) {
            listener();
        }
    }

    signOut() {
        for (const listener of this.listeners.signout) {
            listener();
        }
    }

    revokeSession() {
        for (const listener of this.listeners.revoke) {
            listener();
        }
    }
}
